import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn, FaBug, FaTasks, FaPython, FaJava, FaReact, FaGitAlt, FaJenkins } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import { SiSelenium, SiPlaywright, SiPostman, SiJira, SiTailwindcss, SiApachejmeter } from "react-icons/si";

// Inline style applied to every skill icon so it stays visible regardless of
// the theme/background — avoids relying on an inherited dark color from
// .tech-icons that disappears on dark backgrounds.
const iconStyle = {
  color: "#e6d9ff",
  filter: "drop-shadow(0 0 4px rgba(184, 133, 255, 0.6))",
};

const labelStyle = { fontSize: "0.3em", marginTop: "10px", color: "#e6d9ff" };

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              <h3 className="purple">Quality Assurance Professional</h3>
              <br />
              <br />
              I&apos;m passionate about delivering high-quality software and
              ensuring every product meets the highest standards of reliability,
              performance, and user experience.
              <br />
              <br />
              As a <b className="purple">QA Professional</b>, I specialize in
              <i>
                <b className="purple">
                  {" "}
                  Manual Testing, Automation Testing, Test Planning, Bug
                  Tracking, and Quality Assurance
                </b>
              </i>
              . I focus on identifying issues early, improving software quality,
              and ensuring smooth, bug-free releases.
              <br />
              <br />
              I believe quality is more than finding bugs-it&apos;s about
              <i>
                <b className="purple"> building confidence in every release</b>
              </i>
              .
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        {/* Skills Section */}
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col xs={4} md={2} className="tech-icons">
            <FaBug style={iconStyle} />
            <p style={labelStyle}>QA Testing</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <GiCheckMark style={iconStyle} />
            <p style={labelStyle}>Test Automation</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaTasks style={iconStyle} />
            <p style={labelStyle}>Project Management</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiSelenium style={iconStyle} />
            <p style={labelStyle}>Selenium</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiPlaywright style={iconStyle} />
            <p style={labelStyle}>Playwright</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaPython style={iconStyle} />
            <p style={labelStyle}>Python</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaJava style={iconStyle} />
            <p style={labelStyle}>Java</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiPostman style={iconStyle} />
            <p style={labelStyle}>API Testing</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiApachejmeter style={iconStyle} />
            <p style={labelStyle}>Performance Testing</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaReact style={iconStyle} />
            <p style={labelStyle}>React.js</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiTailwindcss style={iconStyle} />
            <p style={labelStyle}>Tailwind CSS</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaGitAlt style={iconStyle} />
            <p style={labelStyle}>Git</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaJenkins style={iconStyle} />
            <p style={labelStyle}>CI/CD</p>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiJira style={iconStyle} />
            <p style={labelStyle}>JIRA</p>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/tandukarunique"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/UniqueTand33478"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/unique-tandukar-86a7171a1/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/unique_tandukar1/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
